import React from "react";
import { Link, Text, Image } from "@chakra-ui/react";
import { isBrowser } from "react-device-detect";
import { Link as RouterLink } from "react-router-dom";

export const NavLink = ({
  content,
  to,
  icon,
  active,
  onClose,
}: {
  content: string;
  to: string;
  icon: any;
  active: boolean;
  onClose: () => void;
}) => (
  <Link
    to={to}
    as={RouterLink}
    display="flex"
    my="20px"
    alignItems="center"
    onClick={onClose}
  >
    <Image
      src={icon}
      boxSize={isBrowser ? { base: "40px", xs: "25px" } : "40px"}
      mr="10px"
    />
    {active ? (
      <Text
        fontSize={isBrowser ? "0.875rem" : "1.4rem"}
        color="white.0"
        fontWeight="bold"
      >
        {content}
      </Text>
    ) : (
      <Text fontSize={isBrowser ? "0.875rem" : "1.4rem"} color="black.300">
        {content}
      </Text>
    )}
  </Link>
);
